import { render } from "./AnswerCollectionInvitationView.vue?vue&type=template&id=840f3d82&scoped=true"
import script from "./AnswerCollectionInvitationView.vue?vue&type=script&lang=js"
export * from "./AnswerCollectionInvitationView.vue?vue&type=script&lang=js"

import "./AnswerCollectionInvitationView.vue?vue&type=style&index=0&id=840f3d82&lang=less&scoped=true"

import exportComponent from "/home/rampa/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-840f3d82"]])

export default __exports__